/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "./ui/Icon";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
} from "./ui/DropdownMenu";
import Button from "./ui/Button";
import { useTranslate } from "../hooks/useTranslate";

const NavigationDropdown = ({ navigationItems }) => {
  const navigate = useNavigate();
  const { _t } = useTranslate();

  const handleItemClick = (item) => {
    item.onBeforeNavigate?.();
    navigate(item.route);
  };

  return (
    <DropdownMenu placement="bottom-left">
      <DropdownMenuTrigger>
        <Button variant="transparent" size="icon" icon={<Icon.Burger size={Icon.SIZE.SM} color="dark" aria-label={_t("Menu")} aria-haspopup="menu" />} />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {navigationItems.map((item, index) => (
          <DropdownMenuItem key={index} title={item.label} onClick={() => handleItemClick(item)} />
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default NavigationDropdown;
